import {
  stat
} from "fs";

export const dialogModal = {
  namespaced: true,
  state: {
    openNewProj: false,
    open_modal_img: false,
    open_infoimg: false,
    open_sort: false,
    open_responsivity: false,
    open_movedir: false,
    dataNotif: {open: false, title: null, message: null}
  },
  getters: {
    isOpenNewProj: state => {
      return state.openNewProj;
    },
    isOpenModalImg: state => {
      return state.open_modal_img;
    },
    isOpenInfoImg: state => {
      return state.open_infoimg;
    },
    isOpenSort: state => {
      return state.open_sort;
    },
    isOpenResponsivity: state => {
      return state.open_responsivity;
    },
    isOpenMovedir: state => {
      return state.open_movedir;
    },
    getDataNotif: state => {
      return state.dataNotif;
    }
  },
  mutations: {
    setOpen(state) {
      state.openNewProj = !state.openNewProj;
    },
    setOpenMovedir(state) {
      state.open_movedir = !state.open_movedir;
    },
    setOpenModalImg(state) {
      state.open_modal_img = !state.open_modal_img;
    },
    setOpenInfoImg(state) {
      state.open_infoimg = !state.open_infoimg;
    },
    setOpenSort(state) {
      state.open_sort = !state.open_sort;
    },
    setOpenResponsivity(state) {
      state.open_responsivity = !state.open_responsivity;
    },
    toggleNotif(state, [title, message] = []) {
      state.dataNotif.open = !state.dataNotif.open;
      state.dataNotif.title = title;
      state.dataNotif.message = message;
    },
    showNotif(state, [title, message] = []) {
      state.dataNotif.open = !state.dataNotif.open;
      state.dataNotif.title = title;
      state.dataNotif.message = message;
    }
  },
  actions: {
    toggle({
      commit
    }) {
      commit("setOpen");
    },
    toggleModalImg({ state, commit }) {
      commit("setOpenModalImg");
    },
    toggleInfoImg({
      state,
      commit
    }) {
      commit("setOpenInfoImg");
    },
    toggleSort({
      state,
      commit
    }) {
      commit("setOpenSort");
    },
    toggleResponsivity({
      state,
      commit
    }) {
      commit("setOpenResponsivity");
    },
    toggleMovedir({
      state,
      commit
    }) {
      commit("setOpenMovedir");
    },
  }
};